var fair = {
    search: function(){

        $('body').prepend('<div class="rebuy_fileter_bg"></div>');

        $('.rebuy-smart-search-results-page-sidebar__context-right').append('<div class="Filter_Sort">Filter & Sort</div>');

        $('body').on('click', '.Filter_Sort', function(){
            $('.rebuy-smart-search-results-page__filter-section').addClass('active');
            $('.rebuy_fileter_bg').addClass('active');
        });

         $('body').on('click', '.rebuy_fileter_bg', function(){
            $('.rebuy-smart-search-results-page__filter-section').removeClass('active');
            $(this).removeClass('active');
        });
    },
     Embroidery: function(){

        var g_color ='White'; g_text = '';

        $('.adpt_bg, .adpt_close').on('click', function(){
            $('.adpt_seciton').removeClass('active');
        });

        $('.adpt_addtocart').on('click', function(){
            setTimeout(function(){
                $('.adpt_seciton').removeClass('active');
            }, 2000);            
        });

        

        $('.addon_style').on('click', function(){
            $('.adpt_seciton').addClass('active');

            
            var id = $('select[name="id"]').val();
            $('.product_addon_id').val(id);
            /*
            $('.spb-productoptiontextcolor').prop('checked', true);
            var price = $('.spb-productoptiontextcolor').val();
            console.log(price);
            $('#infiniteoptions-container [name="properties[monogram fee]"]').val(price);
            */
        });

        $('#infiniteoptions-container').on('click', function(){
            setTimeout(function(){
                if($('.spb-productoptiontextcolor').is(':checked')){
                    $('.adpt_seciton').addClass('active');   
                    var id = $('select[name="id"]').val();
                    $('.product_addon_id').val(id);
                }
            }, 20);
             
             
        });
        $('.type_icon_txt[name="type"]').on('change', function(){
             

             var value =$(this).val(); 
             $('.adpt_active_box').removeClass('active');
             $('.adpt_active_box[data-value="'+value+'"]').addClass('active');

             $('.adptli__icon, .adpttxt_txt_value').attr('name', 'null');

             // uncheck 
             if(value == 'icon'){
                var img = $('.adptli__icon:checked').data('img');
                // $('.adptli__icon').attr('name', 'properties[Icon]');

                var img_val = $('.adptli__icon:checked').val();

                if(typeof img !== 'undefined'){
                    //$('.adptpd_value').html('<img src="'+img+'">');

                    $('.adpt_style_href').addClass('active');
                    $('.adpt_addtocart').prop('disabled', false);
                    text_value(img_val);
                }else{
                    $('.adpt_style_href').removeClass('active');
                    $('.adpt_addtocart').prop('disabled', true);

                }
                

             }else{
                var text = $('.adpttxt_txt_value').val(); 
                //$('.adptpd_value').html(text);

                //$('.adpttxt_txt_value').attr('name', 'properties[Text]');

               
                text_value(text);
                 if($('.adpttxt_txt_value').val() == ''){
                    $('.adpt_style_href').removeClass('active');
                    $('.adpt_addtocart').prop('disabled', true);
                    
                 }else{
                    $('.adpt_style_href').addClass('active');
                    $('.adpt_addtocart').prop('disabled', false);
                 }
             }

        });
        $('.dptli_txt_color').on('change', function(){ 
            var color = $(this).data('val'); 
            //$('.adptpd_value').css('color', color);
            $('.adptls_color_value').html($(this).val());

            color_value($(this).val());

        });
        $('.adptli__icon').on('change', function(){ 
            var img = $(this).data('img');
            if(img !== ''){
                //$('.adptpd_value').html('<img src="'+img+'">');
                text_value($(this).val());
            }
            
            

        }); 

        $('.adpttxt_txt_value').on('input', function(){
            var value= $(this).val(); 
            if (value.length > 3) {
                value = value.slice(0, 3);
                $(this).val(value);   
                
            }else{
                $('.adpttxt_display, .adptpd_value').html(value); 
            }

             text_value(value);

            if(value == ''){
                $('.adpttxt_display').html('ABC');
                $('.adptpd_value').html('');

                $('.adpt_style_href').removeClass('active');
                $('.adpt_addtocart').prop('disabled', true);
            }else{
                $('.adpt_style_href').addClass('active');
                $('.adpt_addtocart').prop('disabled', false);
            } 
        });

        $('.next_prev').on('click', function(){
            var id = $(this).data('id'); 

            if(id == 2){
                if(!$('.type_icon_txt[name="type"]').is(':checked')){
                    return; 
                }
            }  

            $('.adpt_step').removeClass('active');
            $('.adpt_step[data-id="'+id+'"]').addClass('active');
        });

        $('.adpt_style_href').on('click', function(){
                if($(this).hasClass('active')){  }
                    $('.adpt_step').removeClass('active');
                    $('.adpt_step[data-id="2"]').addClass('active');
                               
        });


        function color_value(text){
            g_color = text;            
            $('[name="properties[Color]"]').val(text).trigger('change').trigger('input');
            hide_value();
        }
        function text_value(text){
            g_text = text;
            $('[name="properties[Text]"]').val(text).trigger('change').trigger('input');
            hide_value();
        }
        function hide_value(){
            var text = '{"Text":"'+g_text+'","Color":"'+g_color+'", "Monogram Fee":"13"}';
            $('[name="properties[_io_properties]"]').val(text).trigger('change').trigger('input');
            
        }

    },
    menu: function(){
        $('.menu_btn_submenu').on('click', function(){
            $(this).toggleClass('active');
            $(this).next('.hide_menu_submenu').slideToggle();
        });

    },
    Product: function(){
        var checkSwiper = setInterval(function() {
            if (document.querySelector('.js-product-swiper-container-pdp')) {
            clearInterval(checkSwiper);

            // Access the Swiper instance
            var productSwiper = document.querySelector('.js-product-swiper-container-pdp').swiper;

            // Next button
            $('.btn-next').on('click', function() {
                if (productSwiper) productSwiper.slideNext();
            });

            // Prev button
            $('.btn-prev').on('click', function() {
                if (productSwiper) productSwiper.slidePrev();
            });
            }
        }, 300);
    },
    variant_option: function(){
        $('.js-hero-product-option-group-value').on('change', function(){
               // var titleToFind = $('.js-hero-product-variant-select-element[name="id"] option:selected').data('title');
                check_soldOut();   
        });
        $('body').on('change', '.js-quick-add-product-option-group-value', function() {            
            var titleToFind = $('.js-quick-add-product-variant-select-element[name="id"] option:selected').data('title');
          //  check_soldOut(titleToFind);   
        });

        check_soldOut();

        function check_soldOut(){

            //var titleToFind = $(this).val(); 
            var result = [];
            $('.rounde_custome_outer').addClass('out-of-stock');

            //console.log(grouped_product);  

            var titleToFind = $('.js-hero-product-variant-select-element[name="id"] option:selected').data('title');
            
            if(titleToFind){
                $.each(grouped_product, function(i, product) {
                    $.each(product.g_variant, function(j, variant) {
                        if (variant.title.toLowerCase() === titleToFind.toLowerCase()) {
                        result.push({
                            product_id: product.product_id,
                            available: variant.available,
                            variant_id: variant.id
                        });
                        }
                    });
                });       
 
                $.each(result, function(i, item){
                    if(item.available){
                        $('.rounde_custome_outer[data-product_id="'+item.product_id+'"]').removeClass('out-of-stock');                        
                    }
                        var href = $('.rounde_custome[data-product_id="'+item.product_id+'"]').attr('href');
                        var newHref = href.replace(/variant=\d+/, 'variant='+item.variant_id);
                        $('.rounde_custome[data-product_id="'+item.product_id+'"]').attr('href', newHref);
                });
            }

        }

    }
}
$(function() {
    setTimeout(() => {
        // fair.search();
    }, 5900);

    fair.Embroidery();
    fair.menu();

    fair.Product();

    fair.variant_option();


    $('.js-add-to-bag-cta').hide();
    setTimeout(function(){
        $('.js-add-to-bag-cta').css('display', 'flex');
    }, 3000);
})